/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {fetchData, toasterrormsg} from '../../../../reusable'
import {Tr} from '../../../../_metronic/i18n/Tr'

export function Overview() {
  //overview states
  let t = Tr()

  const [fullName, setFullName] = useState('')
  const [countryCode, setCountryCode] = useState('')
  const [mobileNumber, setMobileNumber] = useState('')
  const [email, setEmail] = useState('')

  //profile state

  // view profile api call
  const viewprofile = async () => {
    var tmp: any = sessionStorage.getItem('admin')
    tmp = JSON.parse(tmp)

    var param: any = {
      adminId: String(tmp.adminId),
    }
    var res = await fetchData('admin/viewProfile', param)

    if (res.status == '200') {
      var data = res.data[0]

      setFullName(data['fullName'])
      setCountryCode(data['countryCode'])
      setEmail(data['email'])
      setMobileNumber(data['mobileNumber'])

      tmp['fullName'] = data['fullName']
      tmp['mobile_number'] = data['mobileNumber']
      tmp['email'] = data['email']
      tmp['profilePicture'] = data['profilePicture']
      tmp['country_code'] = data['countryCode']

      sessionStorage.setItem('admin', JSON.stringify(tmp))
    } else {
      toasterrormsg(res.message)
    }
  }
  useEffect(() => {
    document.title = 'Insayr | Profile Overview'

    viewprofile()
  }, [])
  return (
    <>
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header cursor-pointer'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>{t('Profile Details')}</h3>
          </div>

          <Link to='../settings' className='btn btn-success monthBtn align-self-center'>
            {t('Edit Profile')}
          </Link>
        </div>

        <div className='card-body p-9'>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>{t('Full Name')}</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>{fullName}</span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>{t('Mobile Number')}</label>

            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>
                +{countryCode != null && countryCode != 'null' ? countryCode : ''} {mobileNumber}
              </span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>{t('Email')}</label>

            <div className='col-lg-8'>
              <a href='#' className='fw-bold fs-6 text-dark text-hover-primary'>
                {email}
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
